import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
	selector: '[maskphone]',
})
export class MaskPhoneDirective {

	constructor(private el: ElementRef) {
	}

	@HostListener('keyup', ['$event']) onkeyup(event) {


		let input = (this.el.nativeElement as HTMLInputElement).value;

		if (event.key == 'Backspace') {
			if (input.length == 14) {
				input = input.toString().replace(/\D/g, '');
				input = input.replace(/^(\d{0,2})(\d{0,4})(\d.*)/, '($1) $2-$3');
				this.setValueInput(input)
			}
			return;
		}

		if (input.length > 15) {
			input = input.toString().substring(0, input.length - 1);
			this.setValueInput(input)
			return;
		}

		// remove all mask characters (keep only numeric)
		input = input.toString().replace(/\D/g, '');

		// don't show braces for empty value
		if (input.length == 0) {
			input = '';
		}
		// don't show braces for empty groups at the end
		else if (input.length <= 2) {
			input = input.replace(/^(\d{0,2})/, '($1)');
		} else if (input.length <= 6) {
			input = input.replace(/^(\d{0,2})(\d{0,4})/, '($1) $2');
		} else {
			if (input.length <= 10) {
				input = input.replace(/^(\d{0,2})(\d{0,4})(\d.*)/, '($1) $2-$3');
			} else {
				input = input.replace(/^(\d{0,2})(\d{0,5})(\d.*)/, '($1) $2-$3');
			}
		}
		// set the new value
		this.setValueInput(input)
	}

	//Set value
	setValueInput(value) {
		(this.el.nativeElement as HTMLInputElement).value = value;
	}

}



// WEBPACK FOOTER //
// ./src/app/directives/mask-phone/mask-phone.directive.ts